/* Copyright (c) 2022 MOCA Systems, Inc. All rights reserved. */

import { GroupBy } from './GroupBy';

export enum SortGroupsBy {
	StartDate = 'startDate',
	Location = GroupBy.Location,
	Swimlane = GroupBy.Swimlane,
	Wbs = GroupBy.Wbs,
}
